/**
 * ParallaxLayer — wraps a PixiJS Container with a scroll rate.
 * Each frame, offsets position to counteract camera movement,
 * creating depth through differential scrolling.
 */

import { Container } from 'pixi.js';

export class ParallaxLayer {
  readonly container: Container;
  readonly scrollRate: number;

  // "Home" position — camera position when layer was created
  private homeX = 0;
  private homeY = 0;

  constructor(scrollRate: number) {
    this.container = new Container();
    this.scrollRate = scrollRate;
  }

  /** Set the initial camera position (call once after camera init). */
  setHome(camX: number, camY: number): void {
    this.homeX = camX;
    this.homeY = camY;
  }

  /** Update parallax offset from current camera position. */
  updateParallax(camX: number, camY: number): void {
    this.container.x = (camX - this.homeX) * (1 - this.scrollRate);
    this.container.y = (camY - this.homeY) * (1 - this.scrollRate);
  }

  /** Destroy all children. */
  clear(): void {
    this.container.removeChildren();
  }
}
